/**
 * UNIFIED GAME CONFIGURATION - SINGLE SOURCE OF TRUTH
 * ====================================================
 * This file imports the base game data and marries it with the
 * client-side logic (components, compare functions, etc.).
 */

// Import all game-specific logic and components
import bibleBooksLogic from './games/bibleBooksConfig';
import slayTheSpireLogic from './games/slayTheSpireConfig';
import subnauticaCreaturesLogic from './games/subnauticaCreaturesConfig';
import aoe2UnitsLogic from './games/aoe2UnitsConfig';
import pokemonLogic from './games/pokemonConfig';

// Import the base data from CommonJS module (default-import returns module.exports)
import SharedConfig from '../shared/config/gameConfig.data.js';
const { UNIFIED_GAMES_CONFIG_DATA } = SharedConfig;

// Map logic to game IDs
const gameLogics = {
  'bible-books': bibleBooksLogic,
  'slay-the-spire': slayTheSpireLogic,
  'subnautica-creatures': subnauticaCreaturesLogic,
  'aoe2-units': aoe2UnitsLogic,
  'pokemon': pokemonLogic,
};

// Combine the data with the logic
export const UNIFIED_GAMES_CONFIG = UNIFIED_GAMES_CONFIG_DATA.map(game => ({
  ...game,
  logic: gameLogics[game.id],
}));
